import { InjectionToken } from '@angular/core';

export interface AppAccountConfig {
	smallLogoUrl: string;
	mainLogoUrl: string;
	appName: string;
}

export const APP_ACCOUNT_CONFIG = new InjectionToken<AppAccountConfig>('APP_ACCOUNT_CONFIG');
